// extracted by mini-css-extract-plugin
export default {"projectsBlock":"ProjecktsBlock_projectsBlock__JHSws","projectsContainer":"ProjecktsBlock_projectsContainer__R0aF8","projects":"ProjecktsBlock_projects__+pJ3q"};